package com.anjuros.website.templates.template8.styles

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Template8Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#D4AF37", rgb = rgb(r = 212, g = 175, b = 55)),
    Opacity(hex = "#D4AF37", argb(a=0.8f, r = 212, g = 175, b = 55)),
    Gold1(hex = "#D4AF37", rgb = rgb(r = 212, g = 175, b = 55)),
    Gold2(hex = "#FCEABB", rgb = rgb(r = 252, g = 234, b = 187)),
    Gold3(hex = "#FFFDF7", rgb = rgb(r = 255, g = 253, b = 247)),
    DarkGrey(hex = "#F9F9F9", argb(a=0.8f,r = 36, g = 37, b = 43)),
    LightGrey(hex = "#E5D9D2", rgb = rgb(r = 229, g = 217, b = 210)),
}

@Composable
fun Template8Theme.getColor():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template8Theme.getColorOpacity():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColorOpacity.rgb
}